module.exports = __webpack_public_path__ + "img/caseimage.26eab7fa.jpeg";